import { create } from "zustand";
import type { AppTheme } from "../types";

interface ThemeState {
  theme: AppTheme;
  setTheme: (theme: AppTheme) => void;
  toggleNextTheme: () => void;
}

const THEMES: AppTheme[] = ["dark", "light", "funky", "halloween"];

const getInitialTheme = (): AppTheme => {
  const saved = localStorage.getItem("squad-a-roke-theme") as AppTheme;
  return THEMES.includes(saved) ? saved : "dark";
};

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: getInitialTheme(),
  setTheme: (theme) => {
    localStorage.setItem("squad-a-roke-theme", theme);
    document.body.className = theme === "dark" ? "" : `theme-${theme}`;
    set({ theme });
  },
  toggleNextTheme: () => {
    const current = get().theme;
    const nextIndex = (THEMES.indexOf(current) + 1) % THEMES.length;
    const nextTheme = THEMES[nextIndex];
    get().setTheme(nextTheme);
  },
}));
